<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    
    <template v-slot:activator="{ on }">
       <v-btn v-if="id" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn v-else color="primary" dark fab small v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
       <v-card-text class="mt-2">
        <v-form ref="form" v-model="isValidSite" :disabled="loadingSave">
          <v-row>
            <v-col cols="12" v-if="serverError">
              <v-alert 
                dense 
                outlined
                type="error" 
                :value="Boolean(serverError)"
                transition="scale-transition"
              >
                {{ serverError }}
              </v-alert>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card outlined>
                <v-card-title>Основная информация</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="siteObj._id"
                    label="ID сайта *"
                    filled
                    disabled
                  >
                  </v-text-field>

                   <v-text-field
                      v-model="siteObj.name"
                      label="Название сайта *"
                      :rules="[v => !!v || 'Введите название сайта.']"
                      @focus="serverError = ''"
                      filled
                      :disabled="!isAdmin"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.url"
                      label="URL *"
                      :rules="[v => !!v || 'Введите URL.', v => isUrl(v) || 'Введите корректный URL.']"
                      @focus="serverError = ''"
                      filled
                      :disabled="!isAdmin"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.city.name"
                      label="Город *"
                      :rules="[v => !!v || 'Введите название города.']"
                      @focus="serverError = ''"
                      filled
                      :disabled="!isAdmin"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.city.nameWhere"
                      label="Город (где)"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.city.peopleName"
                      label="Название жителей"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>
                    
                    <v-text-field
                      v-model="siteObj.city.peopleNameWhom"
                      label="Название жителей (кого)"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>

                    <v-select
                      v-model="siteObj.city.timeZone"
                      :items="timeZones"
                      label="Часовой пояс *"
                      filled
                      :disabled="!isAdmin"
                    ></v-select>

                    <v-switch 
                      label="4-х значный код телефона"
                      v-model="siteObj.city.phone4"
                      :disabled="!isAdmin"
                    ></v-switch>

                    <v-switch 
                      label="В городе есть Леруа Мерлен"
                      v-model="siteObj.city.leroyMerlin"
                    ></v-switch>

                    <v-text-field
                      v-model="siteObj.city.wordstatBase"
                      label="Wordstat (ремонт квартир)"
                      filled
                      :rules="[v => !v || isNumber(v) || 'Укажите число']"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.city.population"
                      label="Население (тыс. жителей)"
                      filled
                      :rules="[v => !v || isNumber(v) || 'Укажите число']"
                    >
                    </v-text-field>

                    <v-switch 
                      label="Старый сайт"
                      v-model="siteObj.isOldSite"
                    ></v-switch>

                     <small>* Поля обязательные для заполнения</small>
                </v-card-text>
              </v-card>
              
              <v-card class="mt-7" outlined>
                <v-card-title>
                  Интеграция с площадками
                  <v-spacer></v-spacer>
                  <v-switch
                    v-model="siteObj.systemMarks.isActive"
                  ></v-switch>
                </v-card-title>
                <v-card-text v-if="siteObj.systemMarks.isActive">
                  <v-text-field
                    v-model="siteObj.systemMarks.yaMetrika"
                    label="Yandex.Metrika ID"
                    @focus="serverError = ''"
                    filled
                  >
                  </v-text-field>

                  <v-text-field
                    v-model="siteObj.systemMarks.yaSprav"
                    label="Yandex.Sprav ID"
                    @focus="serverError = ''"
                    filled
                  >
                  </v-text-field>

                  <v-text-field
                    v-model="siteObj.systemMarks.fbPixel"
                    label="Facebook.pixel ID"
                    @focus="serverError = ''"
                    filled
                  >
                  </v-text-field>

                  <v-text-field
                    v-model="siteObj.systemMarks.gaId"
                    label="Google.Analytics ID"
                    @focus="serverError = ''"
                    filled
                  >
                  </v-text-field>
                 </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6">
              <v-card outlined>
                <v-card-title>Организация</v-card-title>
                <v-card-text>
                    <v-text-field
                      v-model="siteObj.organization.name"
                      label="Имя руководителя"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.nameWhom"
                      label="Имя руководителя (кого)"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="siteObj.organization.nameWhom1"
                      label="Имя руководителя (кем)"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.objectsPerYear"
                      label="Среднее число объектов (в год)"
                      @focus="serverError = ''"
                      filled
                      :rules="[v => isNumber(v) || 'Введите корректное число.']"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.address"
                      label="Адрес"
                      @focus="serverError = ''"
                      filled
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.email"
                      label="Email"
                      @focus="serverError = ''"
                      :rules="[v => !v || isEmail(v) || 'Введите корректный email.']"
                      filled
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.vkUrl"
                      label="ВКонтакте"
                      @focus="serverError = ''"
                      filled
                      :rules="[v => !v || isUrl(v) || 'Введите корректный URL.']"
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="siteObj.organization.instagramUrl"
                      label="Instagram"
                      @focus="serverError = ''"
                      filled
                      :rules="[v => !v || isUrl(v) || 'Введите корректный URL.']"
                    >
                    </v-text-field>
                </v-card-text>
              </v-card>

              <v-card class="mt-7" outlined>
                <v-card-title>Прайс-лист</v-card-title>
                <v-card-text>
                  <v-autocomplete
                    label="Применяемый прайс-лист"
                    :items="pricesSelectData"
                    v-model="siteObj.priceMarks.price"
                    filled
                  ></v-autocomplete>
                  <v-text-field
                    v-model="siteObj.priceMarks.servicesCoeff"
                    label="Коэффициент на работы"
                    filled
                    :rules="[v => isNumber(v) || 'Введите корректное число.']"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="siteObj.priceMarks.materialsCoeff"
                    label="Коэффициент на материалы"
                    filled
                    :rules="[v => isNumber(v) || 'Введите корректное число.']"
                  >
                  </v-text-field>
                </v-card-text>
              </v-card>
              
              
            </v-col>
          </v-row>

           <v-card class="mt-3" outlined>
              <v-card-title>
                Рекламные каналы
                <v-spacer></v-spacer>

                <marketing-channel 
                  v-model="newChannel" 
                  :allchannels="siteObj.marketingChannels"
                ></marketing-channel>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="marketingChannelsHeaders"
                  :items="siteObj.marketingChannels"
                  item-key="_id"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <marketing-channel 
                      v-model="siteObj.marketingChannels[siteObj.marketingChannels.indexOf(item)]" 
                      :allchannels="siteObj.marketingChannels"
                    ></marketing-channel>

                    <delete-button
                      :id="item"
                      objName="рекламный канал"
                      :deleteFunc="deleteChannel"
                      v-if="item.tagName != '-'"
                    >
                      Название канала: {{ item.name }} 
                    </delete-button>
                  </template>

                  <template v-slot:[`item.dates`]="{ item }">
                    {{ item.startedAt ? 'с ' : ''}}
                    {{ item.startedAt | localDate }} 
                    <br v-if="item.startedAt && item.finishedAt">
                    {{ item.finishedAt ? 'до' : '' }}
                    {{ item.finishedAt | localDate }}
                  </template>
                </v-data-table>
              </v-card-text>
           </v-card>

           <v-card class="mt-6" outlined v-if="isAdmin">
              <v-card-title>
                Договоры аренды
                <v-spacer></v-spacer>

                <rent-deal 
                  v-model="newRentDeal"
                  :allDeals="siteObj.rentDeals"
                ></rent-deal>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="rentDealsHeaders"
                  :items="siteObj.rentDeals"
                  item-key="_id"
                  disable-pagination
                  hide-default-footer
                >

                  <template v-slot:[`item.startedAt`]="{ item }">
                    {{ item.startedAt | localDate }} 
                  </template>

                  <template v-slot:[`item.finishedAt`]="{ item }">
                    {{ item.finishedAt | localDate }} 
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <rent-deal
                      v-model="siteObj.rentDeals[siteObj.rentDeals.indexOf(item)]" 
                      :allDeals="siteObj.rentDeals"
                    ></rent-deal>

                    <delete-button
                      :id="item"
                      objName="договор аренды"
                      :deleteFunc="deleteRentDeal"
                    >
                    </delete-button>
                  </template>

                </v-data-table>
              </v-card-text>
           </v-card>

        </v-form>
       </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>

          <v-btn 
            color="blue darken-1" 
            text 
            @click="save"
            :disabled="loadingSave"
            :loading="loadingSave"
          >Сохранить</v-btn>

        </v-card-actions>

    </v-card>

 </v-dialog>
</template>

<script>
import MarketingChannel from './MarketingChannelCard';
import RentDeal from './RentDealCard';
import validator from 'validator';
import { mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import { getTempId } from '../../../models/common';

export default {
  name: 'site-card',

  props: {
    id: String
  },

  components: {
    MarketingChannel,
    RentDeal,
  },

  data() {
    let site = this.id ? this.$store.getters['sites/getSiteById'](this.id) : null;
    return {
      site,
      activeMode: false,
      serverError: '',
      isValidSite: false,
      
      title: site ? `Карточка сайта: ${site.name}` : 'Создание сайта',

      siteObj: site ? _.cloneDeep(site) : this.setDefaultObj(),

      newChannel: null,
      marketingChannelsHeaders: [
        {
          text: 'Название канала',
          value: 'name'
        },
        {
          text: 'Тэг',
          value: 'tagName'
        },
        {
          text: 'Номер телефона',
          value: 'phoneNumber'
        },
        {
          text: 'Даты',
          value: 'dates'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ],
      newRentDeal: null,
      rentDealsHeaders: [
        {
          text: 'Дата начала',
          value: 'startedAt',
        },
        {
          text: 'Дата окончания',
          value: 'finishedAt',
        },
        {
          text: 'Партнер',
          value: 'partner.fullName',
        },
        {
          text: 'Ставка аренды',
          value: 'costPerMonth'
        },
        {
          text: 'Действия',
          value: 'actions'
        },
      ]
    };
  },

  watch: {
    newChannel(val, oldVal) {
      if (val) {
        this.siteObj.marketingChannels.push(val);
        this.newChannel = null;
      } 
    },

    newRentDeal(val, oldVal) {
      if (val) {
        this.siteObj.rentDeals.push(val);
        this.newRentDeal = null;
      } 
    },

    activeMode(val, oldVal) {
      if (val) {
        this.site = this.id ? this.$store.getters['sites/getSiteById'](this.id) : null;
      }
    }
  },

  methods: {
    setDefaultObj() {
      return {
        _id: null,
        name: '',
        url: '',
        isOldSite: false,
        city: {
          name: '',
          timeZone: 3,
          phone4: false,
          peopleName: '',
          nameWhere: '',
          peopleNameWhom: ''
        },
        systemMarks: {
          isActive: true,
          yaMetrika: '',
          yaSprav: '',
          fbPixel: '',
          gaId: ''
        },
        organization: {
          name: '',
          nameWhom: '',
          nameWhom1: '',
          address: '',
          email: '',
          vkUrl: '',
          instagramUrl: '',
          objectsPerYear: 0
        },
        priceMarks: {
          price: null,
          servicesCoeff: 1,
          materialsCoeff: 1
        },

        marketingChannels: [{
          _id: getTempId(),
          name: 'Базовый',
          tagName: '-',
          emailConnector: { isActive: false },
          jivositeConnector: { isActive: false },
          vkConnector: { isActive: false }
        }],

        rentDeals: [], 
      };
    },

    async deleteChannel(item) {
      this.siteObj.marketingChannels.splice(this.siteObj.marketingChannels.indexOf(item), 1);
      return { message: 'Канал успешно удален.'};
    },

    async deleteRentDeal(item) {
      this.siteObj.rentDeals.splice(this.siteObj.marketingChannels.indexOf(item), 1);
      return { message: 'Договор успешно удален.'};
    },

    save() {
      this.$refs.form.validate();

      if (this.isValidSite) {
        this.$store.dispatch('sites/save', this.siteObj)
        .then(result => {
          this.$store.dispatch('showMessage', result.message);
          this.closeForm(true);
        })
        .catch(err => {
          this.serverError = err.message;
          this.scrollUp();
        });
      }
    },

    closeForm(success = false) {
      this.scrollUp();
      this.activeMode = false;
      this.siteObj = this.site ? 
        (!success ? _.cloneDeep(this.site) : this.siteObj) : 
        this.setDefaultObj();
      this.$refs.form.resetValidation();
      this.serverError = false;
    },
  },

  computed: {
    ...mapGetters('sites', ['loadingSave']),
    ...mapState('sites', ['timeZones']),
    ...mapGetters('prices', ['pricesSelectData']),
    ...mapGetters('users', ['isAdmin', 'isEditor']),
  }
}
</script>